
const storyDetails = {
    $standardSliderContainer: undefined,
    $extendedSliderContainer: undefined,
    $storyDetailAccordion:    undefined,

    init() {
        this.$standardSliderContainer = $('.story-detail__image-text:not(.story-detail__carousel-inverse) .slider--story-detail');
        this.$extendedSliderContainer = $('.story-detail__carousel-inverse .slider--story-detail');
        this.$storyDetailAccordion = $('.story-detail__accordion');

        this.buildSlider();

        /**
         * Attach accordion event
         */
        this.$storyDetailAccordion.on('click', '.title', storyDetails.storyAccordionLogic)
    },

    buildSlider() {
        $.each(this.$standardSliderContainer, (index, item) => {
            const $standardSliderWrapper = $(item);
            const standardSlider = tns({
                container:            item,
                mode:                 'carousel',
                items:                1,
                controls:             false,
                nav:                  false,
                speed:                500,
                autoplay:             false,
                autoplayButtonOutput: false,
                mouseDrag:            true,
                loop:                 true,
                center:               true,
                onInit:               () => {
                    $standardSliderWrapper.parents('.story-detail__image-text--slider-wrapper')
                                          .on('click', '.js-storyslider__prev', (evt) => {
                                              evt.preventDefault();
                                              standardSlider.goTo('prev');
                                          });
                    $standardSliderWrapper.parents('.story-detail__image-text--slider-wrapper')
                                          .on('click', '.js-storyslider__next', (evt) => {
                                              evt.preventDefault();
                                              standardSlider.goTo('next');
                                          });
                    setTimeout(() => {
                        this.updateActiveSlideCounter(standardSlider);
                        standardSlider.events.on('indexChanged', ()=>{
                            this.updateActiveSlideCounter(standardSlider)
                        });
                    }, 0);
                }
            });
            this.postInit($standardSliderWrapper);
        });

        $.each(this.$extendedSliderContainer, (index, item) => {
            const $sliderWrapper = $(item);
            let slider = tns({
                container:            item,
                mode:                 'carousel',
                items:                1,
                controls:             false,
                nav:                  false,
                speed:                500,
                autoplay:             false,
                autoplayButtonOutput: false,
                mouseDrag:            true,
                loop:                 true,
                center:               true,
                edgePadding:          9,
                onInit:               () => {
                    $sliderWrapper.parents('.story-detail__image-text--slider-wrapper').on('click', '.js-storyslider__prev', (evt) => {
                        evt.preventDefault();
                        slider.goTo('prev');
                    });
                    $sliderWrapper.parents('.story-detail__image-text--slider-wrapper').on('click', '.js-storyslider__next', (evt) => {
                        evt.preventDefault();
                        slider.goTo('next');
                    });
                }
            });
            this.postInit($sliderWrapper);
        });
    },

    postInit(sliderWrapper) {
        sliderWrapper.removeClass('slider--not-initialized');
        sliderWrapper.parents('.story-detail__image-text--slider-wrapper').append(this.buttonsTemplate());
    },

    buttonsTemplate() {
        return `<div class="story-page__slider-buttons">
                    <button type="button" class="js-storyslider__prev story-detail__arrow story-detail__arrow-left">
                        <svg class="cms-storyslider__icon icon">
                            <use xlink:href="#icon-arrow-left-v2"></use>
                        </svg>
                    </button>
                    <button type="button" class="js-storyslider__next story-detail__arrow story-detail__arrow-right">
                        <svg class="cms-storyslider__icon icon">
                            <use xlink:href="#icon-arrow-right-v2"></use>
                        </svg>
                    </button>
                </div>`;
    },

    updateActiveSlideCounter(standardSlider) {
        const sliderInfo = standardSlider.getInfo();
        $(sliderInfo.container).find('.story-detail__slider-footer')
                               .find('.ng-cloak')
                               .text(`${sliderInfo.displayIndex}/${sliderInfo.slideCount}`)
    },

    storyAccordionLogic($event) {
        $($event.currentTarget).siblings('.content').toggleClass('expanded');
        $($event.currentTarget).toggleClass('expanded');
    }
}

// DOM ready
$(() => {
    if ($('.pageType-StoryDetailPage').length) {
        storyDetails.init();
    }
});
